import React from "react";
import { WrapOptions } from "./Questions.style";
import Options from "./Options";
import Descriptive from "./DescriptiveField";

function QuestionOptions(props) {
  const { questionType, options, answer, images, isQuestionImg } = props;

  return (
    <>
      <WrapOptions columns={questionType === "assertion-reasoning" ? "1fr" : undefined}>
        {options.map((item, idx) => {
          if (questionType === "mmcq")
            return (
              <Options
                isQuestionImg={isQuestionImg}
                images={images ? images[item.optionId] : ""}
                mark={answer.indexOf(item.optionId) !== -1 ? true : false}
                option={item}
              />
            );
          else if (["fillup", "oneword"].includes(questionType))
            return (
              <Options
                isQuestionImg={isQuestionImg}
                images={images ? images[item.optionId] : ""}
                radio={false}
                mark={false}
                option={{
                  optionId: answer[idx].blankId,
                  value: answer[idx].answer,
                }}
              />
            );
          else if (["descriptive"].includes(questionType))
            return (
              <Descriptive
                label={"Answer"}
                isQuestionImg={isQuestionImg}
                images={images ? images[item.optionId] : ""}
                option={{
                  optionId: answer[idx].blankId,
                  value: answer[idx].answer,
                }}
              />
            );

          return (
            <Options
              isTF={questionType==="correctstatement"}
              isQuestionImg={isQuestionImg}
              images={images ? images[item.optionId] : ""}
              mark={item.optionId === (answer?.option || answer)}
              option={item}
            />
          );
        })}
      </WrapOptions>
      {questionType === "assertion-reasoning" ? (
        <Descriptive
          label={"Explanation"}
          option={{
            optionId: "op5",
            value: answer.explanation,
          }}
        />
      ) : (
        <></>
      )}
    </>
  );
}

QuestionOptions.defaultProps = {
  questionType: "Mcq",
};
export default QuestionOptions;
